import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic/LogicEvents';
import { ModuleIsEnabledFilter } from '@gongxigames/framework/core';
import {
    BasePromotionModule,
    SingleSetPromotionStatesMap,
    SingleSetPromotionStates,
    PromotionTypes,
    isEnabledPromotionType,
    CounterData
} from '@gongxigames/framework/promotions';

export class SingleSetPromotionModule extends BasePromotionModule<GlobalEventsMapForBackwardCompatibility> {
    public static readonly NAME: symbol = Symbol.for('SingleSetPromotionModule');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledPromotionType(PromotionTypes.SingleSetPromotion);

    protected setupStates(): void {
        this.addStates(SingleSetPromotionStatesMap);
        this.gotoState(SingleSetPromotionStates.INIT);
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.onCurrentStateHandle(LogicEvents.BALANCE_UPDATED);
    }

    protected getCounterData(): CounterData {
        const { left, total, id, type } = this.getPromotion().getData();

        return { left, total, id, type };
    }
}
